// @ts-check
/*eslint sort-keys: "error"*/

const Constants = /** @type {const} */ ({
  navHeightDesktop: 125, // spacing value defined in Tailwind config
  navHeightMobile: 92, // spacing value defined in Tailwind config
  navigationId: "global-navigation",
  navigationIdMobile: "global-navigation-mobile",
  primaryLinkPrefix: "global-nav-primary-link-",
  primaryLinkPrefixMobile: "global-nav-primary-link-mobile-",
  secondarySectionPrefix: "global-nav-secondary-section-",
  secondarySectionPrefixMobile: "global-nav-secondary-section-mobile-",
  transitionFocus: {
    logo: "logo"
  }
});

export default Constants;
